import { UiComponent } from '@/modules/customization/entities/interfaces/customizations.interfaces';
import { BaseListResponse, RequestCreation, SearchParams } from '@/shared/entities';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

export class UiComponentsService extends HttpClientAdapter {
  constructor() {
    super('SYSTEM');
  }

  createUiComponent(uiComponents: RequestCreation<UiComponent>) {
    return this.post('/ui-components', uiComponents);
  }

  listUiComponents(filters?: Partial<SearchParams<UiComponent>>) {
    return this.get<BaseListResponse<UiComponent>>('/ui-components', filters);
  }

  showUiComponent(id: string | number) {
    return this.get(`/ui-components/${id}`);
  }

  updateUiComponent(id: string | number, uiComponents: Partial<UiComponent>) {
    return this.put(`/ui-components/${id}`, uiComponents);
  }

  deleteUiComponent(id: string | number) {
    return this.delete(`/ui-components/${id}`);
  }
}
